export default function PageIntro({ eyebrow, title, children }) {
  return <section className="ee-intro"><div className="ee-container">
    {eyebrow && <p className="ee-eyebrow">{eyebrow}</p>}
    <h1 className="ee-title">{title}</h1>
    <div className="ee-lead max-w-2xl mt-5">{children}</div>
  </div></section>;
}